<!-- 临时抄表 -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户">
              <UserSelect v-model="query.userCode" @change="onQueryUserChange" :show-debug="true" />
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="12">
            <a-form-item label="抄表员">
              <a-select
                show-search
                :filter-option="filterReaderOption"
                v-model="query.readerId"
                placeholder="请输入抄表员名称搜索"
                allow-clear
              >
                <a-select-option v-for="item in readerList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="抄表状态">
              <a-select placeholder="请选择" v-model="query.pushStatus" allow-clear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="0">未抄表</a-select-option>
                <a-select-option :value="1">已抄表</a-select-option>
                <a-select-option :value="2">已推送</a-select-option>
                <a-select-option :value="3">已逾期</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button
                type="danger"
                style="margin-left: 12px"
                @click="deleteSelectRow()"
                v-action:del
                :disabled="selectedRows.length === 0"
                >删除</a-button
              >
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateH()" v-action:add>新增 </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="tempTaskId"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      :scroll="{ x: 2000 }"
      @change="pageChange"
    >
      <template slot="readingStatus" slot-scope="text">
        <a-tag :color="getReadingStatusColor(text)">{{ getReadingStatusText(text) }}</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="action-container">
          <a
            v-if="record.readingStatus === 0"
            @click="
              tempTaskId = record.tempTaskId
              addOrUpdateHandle(record.id)
            "
            v-action:edit
            >编辑</a
          >
          <a v-else @click="handleViewImages(record)" style="color: #1890ff">查看图片</a>
        </div>
      </template>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="currentId ? '编辑' : '新增'"
      style="top: 20px"
      :width="600"
      :visible="visibles"
      :confirmLoading="submitLoading"
      @ok="approvalko"
      @cancel="handleCancelh"
    >
      <a-alert
        class="prompt"
        style="margin: 15px 0"
        type="info"
        show-icon
        message="保存后，系统将在抄表开始日期当天的00:00:00推送临时任务到抄表app"
      />
      <a-form-model
        class="log-form"
        :model="engineeringProjectEstab"
        ref="ruleForm"
        :rules="rule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="用户" prop="userCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UserSelect v-model="engineeringProjectEstab.userCode" @change="onFormUserChange" :show-debug="true" />
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表员" prop="readerId">
          <a-select
            show-search
            :filter-option="filterReaderOption"
            v-model="engineeringProjectEstab.readerId"
            placeholder="请输入抄表员名称搜索"
            @change="onReaderFormSelectChange"
            allow-clear
          >
            <a-select-option v-for="item in readerList" :key="item.id" :value="item.id">
              {{ item.readerName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="抄表开始日期" prop="startDate">
          <a-date-picker
            v-model="engineeringProjectEstab.startDate"
            :disabled-date="disabledStartDate"
            style="width: 100%"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            placeholder="请选择开始日期"
          />
        </a-form-model-item>
        <a-form-model-item label="抄表结束日期" prop="endDate">
          <a-date-picker
            v-model="engineeringProjectEstab.endDate"
            :disabled-date="disabledEndDate"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%"
            placeholder="请选择结束日期"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="notes">
          <a-textarea
            v-model="engineeringProjectEstab.notes"
            :rows="4"
            placeholder="请输入备注信息"
            :maxLength="200"
            show-count
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 查看图片模态框 -->
    <a-modal
      title="查看抄表图片"
      :width="900"
      :footer="null"
      :visible="imageVisible"
      @cancel="handleImageCancel"
      centered
    >
      <div v-if="currentImages && currentImages.length > 0" class="image-modal-content">
        <div class="image-container">
          <div v-for="(image, index) in currentImages" :key="index" class="image-item">
            <img :src="image" class="meter-image" @click="previewImage(image)" />
          </div>
        </div>
      </div>
      <div v-else class="empty-container">
        <a-empty description="暂无图片" />
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import dayjs from 'dayjs'
import mixinViewModule from '@/mixin/common'
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'

const columns = [
  { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120 },
  { title: '用户名称', dataIndex: 'userName', key: 'userName', width: 120 },
  { title: '水表编号', dataIndex: 'meterNumber', key: 'meterNumber', width: 120 },
  { title: '用户地址', dataIndex: 'address', width: 200, key: 'address', ellipsis: true },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 100 },
  { title: '所属表册', dataIndex: 'bookName', key: 'bookName', width: 120, ellipsis: true },
  { title: '抄表员', dataIndex: 'readerName', key: 'readerName', width: 100 },
  { title: '抄表开始日期', dataIndex: 'startDate', key: 'startDate', width: 120 },
  { title: '抄表结束日期', dataIndex: 'endDate', key: 'endDate', width: 120 },
  { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 100 },
  { title: '上期用水量（m³）', dataIndex: 'previousUsage', key: 'previousUsage', width: 120 },
  { title: '上期抄表时间', dataIndex: 'previousReadingTime', key: 'previousReadingTime', width: 150 },
  { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
  { title: '本期用水量（m³）', dataIndex: 'currentUsage', key: 'currentUsage', width: 120 },
  { title: '补充水量', dataIndex: 'supplementaryWaterAmount', key: 'supplementaryWaterAmount', width: 120 },
  { title: '本期抄表时间', dataIndex: 'currentReadingTime', key: 'currentReadingTime', width: 150 },
  {
    title: '抄表状态',
    dataIndex: 'readingStatus',
    key: 'readingStatus',
    width: 100,
    scopedSlots: { customRender: 'readingStatus' },
  },
  { title: '任务生成时间', dataIndex: 'createTime', width: 150, key: 'createTime' },
  { title: '备注', dataIndex: 'notes', width: 150, key: 'notes', ellipsis: true },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 150,
    fixed: 'right',
  },
]

export default {
  components: {
    dayjs,
    UserSelect,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data() {
    return {
      currentImages: [],
      isMonth: false,
      tempTaskId: '',
      monthList: [],
      dayjs,
      importLoading: false,
      imageVisible: false,
      visibles: false,
      submitLoading: false, // 提交按钮加载状态
      disabled: false,
      fileList: [],
      queryUrl: '/meter-manager/temporary_reading_task/page',
      addOrUpdateUrl: '/meter-manager/temporary_reading_task/create',
      queryOneUrl: '/meter-manager/temporary_reading_task/detail',
      deleteUrl: '/meter-manager/temporary_reading_task/batch',
      query: {
        endDate: '',
        pushStatus: '', // 抄表状态
        pushTime: '',
        readerId: '',
        readerName: '',
        notes: '',
        startDate: '',
        submitTime: '',
        tempTaskId: '',
        userCode: '',
        userName: '',
      },
      engineeringProjectEstab: {
        endDate: '',
        readerId: '',
        readerName: '',
        notes: '',
        reviewId: '',
        startDate: '',
        userCode: '',
        userName: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      rule: {
        userCode: [{ required: true, message: '请输入用户编码', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        readerId: [{ required: true, message: '请选择抄表员', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择抄表开始日期', trigger: 'change' }],
        endDate: [
          { required: true, message: '请选择抄表结束日期', trigger: 'change' },
          { validator: this.validateEndDate, trigger: 'change' },
        ],
      },
      readerList: [], // 抄表员下拉数据
    }
  },

  created() {
    this.getReaderList()
  },
  methods: {
    // 获取抄表状态中文文本
    getReadingStatusText(status) {
      const statusMap = {
        0: '未抄表',
        1: '已抄表',
        2: '已推送',
        3: '已逾期',
      }
      return statusMap[status] || '未知状态'
    },
    // 获取抄表状态颜色
    getReadingStatusColor(status) {
      const colorMap = {
        0: 'red', // 未抄表 - 红色
        1: 'blue', // 已抄表 - 蓝色
        2: 'green', // 已推送 - 绿色
        3: 'orange', // 已逾期 - 橙色
      }
      return colorMap[status] || 'default'
    },
    // 根据id 修改
    addOrUpdateHandle(id) {
      this.disabled = true
      this.isUpdate = false
      this.visibles = true
      this.currentId = id
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.engineeringProjectEstab = {
              bookId: data.bookId,
              readerId: data.readerId,
              readerName: data.readerName,
              notes: data.notes,
              reviewId: data.reviewId,
              startDate: data.startDate,
              endDate: data.endDate,
              userCode: data.userCode,
              userName: data.userName,
            }
            // 回显时，如果有readerId但没有readerName，自动补全
            if (this.engineeringProjectEstab.readerId && !this.engineeringProjectEstab.readerName) {
              const reader = this.readerList.find((r) => r.id === this.engineeringProjectEstab.readerId)
              if (reader) {
                this.engineeringProjectEstab.readerName = reader.readerName
              }
            }
            if (data.taskFrequency == '月') {
              this.isMonth = true
            } else {
              this.isMonth = false
            }
          })
          .catch(() => {})
      }
    },
    // 日期验证方法
    validateEndDate(rule, value, callback) {
      const { startDate } = this.engineeringProjectEstab
      if (value && startDate && dayjs(value).isBefore(dayjs(startDate))) {
        callback(new Error('结束日期必须大于或等于开始日期'))
      } else {
        callback()
      }
    },
    // startOf('day')
    // 时间
    disabledStartDate(current) {
      // 不能选择今天之前的日期，只能选择今天及以后的日期
      return current && current < dayjs().startOf('day')
    },
    // 禁用早于开始日期的结束日期
    // disabledEndDate(endValue) {
    //   const startValue = this.engineeringProjectEstab.startDate
    //   if (!endValue || !startValue) {
    //     return false
    //   }
    //   return dayjs(endValue).isBefore(dayjs(startValue))
    // },
    disabledEndDate(endValue) {
      const startValue = this.engineeringProjectEstab.startDate
      // 如果结束日期早于今天，则禁用
      if (endValue && endValue < dayjs().startOf('day')) {
        return true
      }
      // 如果开始日期存在，则结束日期早于开始日期的也要禁用
      if (startValue) {
        return dayjs(endValue).isBefore(dayjs(startValue))
      }
      return false
    },
    onChangejt(value) {
      if (value.target.value == 2) {
        this.apprOpinion = false
      } else {
        this.apprOpinion = true
      }
    },

    addOrUpdateH() {
      this.disabled = false
      this.visibles = true
    },
    handleCancelh() {
      this.visibles = false
      this.isMonth = false
      this.submitLoading = false
      this.engineeringProjectEstab = {
        endDate: '',
        readerId: '',
        readerName: '',
        notes: '',
        reviewId: '',
        startDate: '',
        userCode: '',
        userName: '',
      }
      this.$refs.ruleForm.resetFields()
    },
    handleImageCancel() {
      this.imageVisible = false
      this.currentImages = []
    },
    // 预览图片
    previewImage(imageUrl) {
      // 使用浏览器默认的图片预览功能
      const link = document.createElement('a')
      link.href = imageUrl
      link.target = '_blank'
      link.click()
    },
    handleViewImage(record) {
      this.currentImages = record.imageUrl ? [record.imageUrl] : []
      this.imageVisible = true
    },
    approvalko() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        try {
          this.submitLoading = true
          const res = await this.$http[!this.currentId ? 'post' : 'put'](
            !this.currentId
              ? '/meter-manager/temporary_reading_task/create'
              : `/meter-manager/temporary_reading_task/update/${this.tempTaskId}`,
            { ...this.engineeringProjectEstab }
          )

          if (res.code === 0) {
            this.$message.success(res.message || '操作成功')
            this.visibles = false
            this.queryList()
            this.$refs.ruleForm.resetFields()
          } else {
            this.$message.warning(res.message || '操作失败')
          }
        } catch (error) {
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleViewImages(record) {
      if (record.imageUrl) {
        this.currentImages = [record.imageUrl] // 将单个图片URL转为数组，保持界面兼容性
        this.imageVisible = true
      } else {
        this.$message.info('该记录暂无图片')
      }
    },

    // 查询表单用户选择变化
    onQueryUserChange(value, user) {
      console.log('查询表单用户选择变化:', value, user)
      if (user) {
        this.query.userName = user.userName
        console.log('设置查询用户名:', user.userName)
      } else {
        this.query.userName = ''
        console.log('清空查询用户名')
      }
    },

    // 新增/编辑表单用户选择变化
    onFormUserChange(value, user) {
      console.log('新增/编辑表单用户选择变化:', value, user)
      if (user) {
        this.engineeringProjectEstab.userName = user.userName
        console.log('设置新增/编辑表单用户名:', user.userName)
      } else {
        this.engineeringProjectEstab.userName = ''
        console.log('清空新增/编辑表单用户名')
      }
    },

    onReaderFormSelectChange(value) {
      const reader = this.readerList.find((r) => r.id === value)
      if (reader) {
        this.engineeringProjectEstab.readerName = reader.readerName
      } else {
        this.engineeringProjectEstab.readerName = ''
      }
    },

    // 抄表员下拉远程搜索
    getReaderList(search = '') {
      this.$http
        .get('/meter-manager/meter_readers/list', { params: { name: search } })
        .then(({ data }) => {
          this.readerList = data || []
        })
        .catch((error) => {
          this.$message.error('获取抄表员列表失败')
          console.error('获取抄表员列表错误:', error)
        })
    },
    filterReaderOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 重置查询条件
    resetList() {
      this.query = {
        endDate: '',
        pushStatus: '',
        pushTime: '',
        readerId: '',
        readerName: '',
        notes: '',
        startDate: '',
        submitTime: '',
        tempTaskId: '',
        userCode: '',
        userName: '',
      }
      this.pagination.current = 1
      this.selectedRows = []

      this.queryList()
    },
    // 删除选中行
    deleteSelectRow() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }

      this.$confirm({
        title: '确认删除',
        content: `确定要删除选中的 ${this.selectedRows.length} 条数据吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$http
            .delete(this.deleteUrl, { data: this.selectedRows })
            .then((data) => {
              console.log(data)

              if (data.code === 0) {
                this.$message.success('删除成功')
                this.selectedRows = []
                this.queryList()
              } else {
                this.$message.error(data.message || '删除失败')
              }
            })
            .catch((error) => {
              this.$message.error('删除失败')
              console.error('删除错误:', error)
            })
        },
      })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}

/deep/ .ant-modal-body {
  padding: 0 24px 24px 24px;
}

// 表格操作列样式
.action-container {
  display: flex;
  justify-content: center;
  gap: 8px;
}

// 表格内容居中
/deep/ .ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
}

// 表格头部居中
/deep/ .ant-table-thead > tr > th {
  text-align: center;
  vertical-align: middle;
}

//调整提示消息位置
/deep/ .prompt.ant-alert {
  display: flex;
  align-items: center;
  text-align: center;
}

//调整提示图标位置
/deep/ .prompt .ant-alert-icon {
  margin-right: 20px; /* 图标与文字间距 */
  position: relative;
  top: -1px;
}

// 图片模态框样式
.image-modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
}

.image-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.meter-image {
  max-width: 600px;
  max-height: 400px;
  width: auto;
  height: auto;
  object-fit: contain;
  cursor: pointer;
  border-radius: 6px;
  transition: transform 0.3s ease;
}

.meter-image:hover {
  transform: scale(1.02);
}

.image-label {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  text-align: center;
}

.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
</style>
